import React, { useEffect, useState } from 'react';
import './App.css';
import { Form } from './components/Form/Form';
import { getStationName, postStationControlLog } from './backend/stationDataFetcher/stationDatafetcher';
import { controlLog, PROCESSINGSTATES } from './types/interfaces';
import { LoadingElement } from './components/LoadingElement/LoadingElement';
import { PostResult } from './types/types';
import logo from './media/lo_v_positiv_rgb.png'
import TutorialSegment from './components/TutorialSegment/TutorialSegment';


function App() {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const stationID = params.get('sid');

  const [stationName, setStationName] = useState<string | null>(null);
  const [processing, setProcessing] = useState<PROCESSINGSTATES>(PROCESSINGSTATES.unset);
  const [validURL, setValidURL] = useState<boolean>(false);

  useEffect(() => {
      const load = async () => {
        if(!stationID) {
          setValidURL(false);
          return;
        }

        try {
          const name = await getStationName(stationID);
          setStationName(name);
          setValidURL(true);
        } catch (error) {
          console.error("Invalid station data request. Is the URL valid?");
          setValidURL(false);
        }
      };

      load()
    }, [stationID])
    
  const  FormSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {

    setProcessing(PROCESSINGSTATES.processing);

    if(stationID) {

      e.preventDefault()
      const target = e.target as HTMLFormElement;

      const data: controlLog = {
        sid: stationID,
        initials: (target.elements.namedItem("initials") as HTMLInputElement).value.toLowerCase(),
        comment: (target.elements.namedItem("comment") as HTMLInputElement).value.toLowerCase(),
        timestamp: new Date(Date.parse((target.elements.namedItem("timestamp") as HTMLInputElement).value)),
        reportedIssue: Boolean(Number((target.elements.namedItem('reportedIssue') as HTMLInputElement).value))
      };

      const storeRes: PostResult = await postStationControlLog(data);
      setProcessing(
        storeRes.success
          ? PROCESSINGSTATES.succeeded
          : PROCESSINGSTATES.failed
      );
    }
  }

  return (
    <div className="App">
      <main>
        {validURL && (
          <>
            {processing === PROCESSINGSTATES.unset && (
              <div>
                <Form stationName={stationName} date={new Date(Date.now())} onSubmit={FormSubmitHandler} />
                <TutorialSegment />
              </div>
            )}
            
            {processing !== PROCESSINGSTATES.unset && (
              <div>
                <h1>{processing}</h1>
                <LoadingElement state={processing} />
              </div>
            )}
          </>
        )}
        {validURL === false && (
          <div style={{width: 600, height: 600, display: "flex", flexDirection: "column", justifyContent: "center", gap: 20, alignItems: "center"}}>
            <img style={{width: 80, height: 80}} src={logo} />
            <h1>404 - Siden finnes ikke</h1>
            <p className='illegalPrompt'>Det kan hende QR-koden din er ugyldig.<br/> Ta kontakt med systemadministrator hvis du tror dette er en feil.</p>
          </div>
        )}
        </main>
    </div>
  );
}

export default App;
